export async function geocode(payload) {
	const geocoder = new google.maps.Geocoder()
	const { results = [] } = await geocoder.geocode(payload)
	return results
}

export async function getCurrentLocation() {
	const { coords: { latitude, longitude } } = await getCurrentCoordinates()
	const locations = await geocode({ location: { lat: latitude, lng: longitude }})
	const currentLocation = locations[0]
	return currentLocation
}

export async function getCurrentCoordinates() {
	return new Promise((resolve, reject) => {
		return navigator
			.geolocation
			.getCurrentPosition(
				position => resolve(position), 
				error => {
					if (error.code === error.TIMEOUT) {
						return getCurrentCoordinates()
					}
					return reject(error)
				},
				{ enableHighAccuracy: true, maximumAge: 0, timeout: 5000 }
			)
	})
}


/* 
	This script [in Javascript] calculates great-circle distances between the two points – that is, 
	the shortest distance over the earth’s surface – using the ‘Haversine’ formula.
	more detail: https://en.wikipedia.org/wiki/Haversine_formula
*/
/**
 * 
 * @param {*} from { lat: number, lng: number } - required
 * @param {*} to { lat: number, lng: number } - required
 * @param {*} unit "m" | "km" - optional(default is m)
 * @returns number
 */
export function getDistanceByHaversine(from, to, unit = 'm') {
	function deg2rad(deg) {
		return deg * (Math.PI/180)
	}

  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(to.lat-from.lat);  // deg2rad below
  const dLon = deg2rad(to.lng-from.lng);
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(from.lat)) * Math.cos(deg2rad(to.lat)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 

	const distanceInKm = R * c;

	const distanceIn = {
		m: distanceInKm * 1000,
		km: distanceInKm,
		default: distanceInKm * 1000
	}

  return distanceIn[unit] || distanceIn.default;
}

export default { geocode, getCurrentCoordinates, getCurrentLocation, getDistanceByHaversine }



// WEBPACK FOOTER //
// ./src/utils/location.js